<div class="FcAgEditor__MenuItem--IconContainer" [innerHTML]="icon | sanitizeHtml" (mousedown)="togglePopup($event)"
     [title]="title">
</div>

<div *ngIf="showPopup" class="FcAgEditor__Popup color-picker">
    <div *ngFor="let colorGroup of presets; trackBy: trackByIndex" class="FcAgEditor__ColorContainer">
        <button class="FcAgEditor__Color" *ngFor="let color of colorGroup; trackBy: trackByIndex"
                [ngStyle]="{backgroundColor: color, color:getContrastYIQ(color)}" [title]="color"
                (mousedown)="onColorSelect($event, color)"
                [ngClass]="{'FcAgEditor__Color--Active': activeColors.includes(color)}"></button>
    </div>

    <button class="FcAgEditor__MenuItem--Button" (mousedown)="remove($event)" [disabled]="!isActive">
        {{getLabel('remove')}}
    </button>
</div>
